import React from "react";
import CoustCardItemModal from "../CoustCard-itemModal/index";

export default function CoustCardRow(props) {
  return (
    <div className="container-CoustCard">
      <div className="container-CoustCardRow">
        <CoustCardItemModal
          title="Custo cativo"
          content=""
          value={props.CustoCativo}
          percent=""
          type=""
          bigger={props.bigger}
          format={props.format}
        />
        <CoustCardItemModal
          title="Custo livre"
          content=""
          value={props.CustoLivre}
          percent=""
          type=""
          bigger={props.bigger}
          format={props.format}
        />
        <CoustCardItemModal
          title="Economia mensal"
          content=""
          value={props.Economia}
          percent=""
          type={props.Economia < 0 ? "3" : "1"}
          bigger={props.bigger}
          format={props.format}
        />
      </div>
    </div>
  );
}
